export function permissionKey(moduleName, action, fieldKey = null) {
  return [moduleName, action, fieldKey || ""].join(":");
}

export function policyKey(moduleName, action) {
  return [moduleName, action].join(":");
}

export function hasPermission(user, moduleName, action, fieldKey = null) {
  if (user?.isSuperAdmin) return true;

  const capabilities = user?.capabilities || null;
  if (capabilities && typeof capabilities === "object") {
    const key = permissionKey(moduleName, action, fieldKey);
    return capabilities[key] === true;
  }

  return false;
}

// Inverted permissions (profiles:view:phone_masked and friends) read as "this role is
// restricted" rather than "this role is allowed", so Super Admin's blanket bypass has to
// flip the other way - hasPermission() returns true for every key they're asked about,
// which would silently mask the number for the one role that must always see it.
export function hasRestriction(user, moduleName, action, fieldKey = null) {
  if (user?.isSuperAdmin) return false;
  return hasPermission(user, moduleName, action, fieldKey);
}

export function getPrimaryRoleName(user) {
  if (user?.effective_role_name) return user.effective_role_name;
  if (user?.role_name) return user.role_name;
  if (Array.isArray(user?.roles) && user.roles[0]?.name) return user.roles[0].name;
  return user?.role_id ? `Role #${user.role_id}` : "User";
}

export function getPolicySummary(user, moduleName, action) {
  return user?.policy_scope?.[policyKey(moduleName, action)] || null;
}
